import { render, staticRenderFns } from "./tags-list-detail.vue?vue&type=template&id=47953e34&"
import script from "./tags-list-detail.vue?vue&type=script&lang=js&"
export * from "./tags-list-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47953e34')) {
      api.createRecord('47953e34', component.options)
    } else {
      api.reload('47953e34', component.options)
    }
    module.hot.accept("./tags-list-detail.vue?vue&type=template&id=47953e34&", function () {
      api.rerender('47953e34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/tags-list-detail.vue"
export default component.exports